import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { State, useStore } from 'store';

import fetchRuns from 'store/fetchRuns';
import getCurrentProjectState from 'store/getCurrentProjectState';
import getProjectId from 'utils/url/getProjectId';
import { IRunsParams } from 'store/buildRunsPath';

import IAsync from 'types/IAsync';
import IPaginatedResponse from 'types/IPaginatedResponse';
import IRunEntry from 'types/IRunEntry';

export default function useAutofetchedRunsAsync({
  page,
  pageSize,
  search,
  state,
  userId,
  hasRunningTasks,
  taskState,
  updatedWithinDays,
  sort,
  order,
}: IRunsParams = {}): IAsync<IPaginatedResponse<IRunEntry>> {
  const runsAsync = useStore((storeState: State) => getCurrentProjectState(storeState).runsAsync);
  const { pathname } = useLocation();
  const projectId = getProjectId();

  useEffect(() => {
    fetchRuns({ page, pageSize, search, state, userId, hasRunningTasks, taskState, updatedWithinDays, sort, order });
  }, [
    pathname,
    projectId,
    page,
    pageSize,
    search,
    state,
    userId,
    hasRunningTasks,
    taskState,
    updatedWithinDays,
    sort,
    order,
  ]);

  return runsAsync;
}
